export const ROUTESPATH = {
  // Public routes
  LOGIN: "/login",
  UNAUTHORIZED: "/unauthorized",
  DEACTIVATED: "/deactivated",

  // Private routes
  ROOT: "/",
  DASHBOARD: "/dashboard",
  JOBS: "/jobs",
  QUOTES: "/quotes",
  QUOTE_DETAIL: "/quotes/:id",
  ORDERS: "/orders",
  ORDER_DETAIL: "/orders/:id",
  ISSUES: "/issues",
  CUSTOMERS: "/customers",
  CUSTOMER_DETAIL: "/customers/:accountId",
  INSTALLERS: "/installers", // Legacy route - redirects to customers
  DEPOTS: "/depots",
  ONBOARDING: "/onboarding",
  CREDIT_CONTROL: "/credit-control",
  PRODUCT_CONFIGURATOR: "/product-configurator",
  ANALYTICS: "/analytics",
  SETTINGS: "/settings",
  PERMISSIONS: "/settings/permissions",
  CATALOG: "/catalog",
  USERMANAGEMENT: "/user-management",
  CURRENCY_EXCHANGE: "/currency-exchange",
  CUSTOMER_DISCOUNT: "/onboarding/:accountId/discount",
  DELIVERY_SETTINGS: "/settings/delivery",
} as const;
